import { render, staticRenderFns } from "./driverDocumentInfo.vue?vue&type=template&id=654e2bf6&scoped=true&"
import script from "./driverDocumentInfo.vue?vue&type=script&lang=js&"
export * from "./driverDocumentInfo.vue?vue&type=script&lang=js&"
import style0 from "./driverDocumentInfo.vue?vue&type=style&index=0&id=654e2bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e2bf6",
  null
  
)

export default component.exports